module.exports = __webpack_public_path__ + "static/media/README.9705c030.md";